import { render, staticRenderFns } from "./developer-bar.vue?vue&type=template&id=1f4d1e12&scoped=true&"
import script from "./developer-bar.ts?vue&type=script&lang=ts&"
export * from "./developer-bar.ts?vue&type=script&lang=ts&"
import style0 from "./developer-bar.scss?vue&type=style&index=0&id=1f4d1e12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4d1e12",
  null
  
)

export default component.exports